export default __webpack_public_path__ + "static/media/external-cloud.260842be.svg";